import * as React from 'react';
import { translate } from 'react-i18next';
import { InfoLine } from './InfoLine';
export var ORDER_REFERENCE_CUSTOM_FIELD_KEY = 'invoices.document.order-number';
export var OrderReference = translate()(function (_a) {
    var customFields = _a.customFields, t = _a.t;
    var orderReferenceCustomField = customFields === null || customFields === void 0 ? void 0 : customFields.find(function (_a) {
        var originCustomFieldKey = _a.originCustomFieldKey;
        return originCustomFieldKey === ORDER_REFERENCE_CUSTOM_FIELD_KEY;
    });
    return orderReferenceCustomField ? (React.createElement(InfoLine, { dataHook: "order-reference" }, t('invoice-view:invoice-view.order-number.label', {
        orderNumber: orderReferenceCustomField.value.value,
    }))) : null;
});
//# sourceMappingURL=OrderReference.js.map